import { useResponsiveContext } from "./ResponsiveContext.js";
var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
export function useMinBreakpoint(minBreakpoint) {
  var {
    breakpoint = 'xs'
  } = useResponsiveContext();
  if (minBreakpoint == null) {
    return false;
  }
  var breakpointIDX = BREAKPOINTS.indexOf(breakpoint);
  var minBreakpointIDX = BREAKPOINTS.indexOf(minBreakpoint);
  return minBreakpointIDX < breakpointIDX;
}